import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { SegmentoTipoContrato } from '../_models/segmento-tipo-contrato';

@Injectable({
  providedIn: 'root'
})
export class SegmentoTipoContratoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/segmentosTiposContratos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as SegmentoTipoContrato[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as SegmentoTipoContrato[] ) );
  }

  obtenerPorSegmento( idSegmento: string ) {
    return this.httClient.get( this.rutServicio + '/segmento/' + idSegmento ).pipe( map( res => res as SegmentoTipoContrato[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as SegmentoTipoContrato ) );
  }

  agregar( regCrear: SegmentoTipoContrato ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as SegmentoTipoContrato ) );
  }

  actualizar( regActualizar: SegmentoTipoContrato ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as SegmentoTipoContrato ) );
  }

}
